
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const securityBreachChallenge: Challenge = {
  id: 'security-breach',
  title: 'Security Breach Attempt',
  description: 'Your operation has been targeted by hackers attempting to compromise your mining pool connection.',
  options: [
    {
      text: 'Implement advanced security protocols',
      outcome: 'Your comprehensive security upgrade was expensive but highly effective.',
      kpiEffects: {
        uptime: 3,
        profitMargin: -2
      },
      experienceGain: 30,
      skillUnlock: skills.find(s => s.id === 'network-optimization')
    },
    {
      text: 'Conduct an internal investigation',
      outcome: 'You identified the vulnerability but experienced some downtime during the process.',
      kpiEffects: {
        uptime: -2,
        profitMargin: -1,
        efficiency: 2
      },
      experienceGain: 20
    },
    {
      text: 'Hire external security consultants',
      outcome: 'The consultants provided expert solutions but at a premium cost.',
      kpiEffects: {
        uptime: 5,
        efficiency: 1,
        profitMargin: -4
      },
      experienceGain: 25,
      skillUnlock: skills.find(s => s.id === 'strategic-planning')
    }
  ],
  difficulty: 4,
  requiredSkills: ['network-optimization']
}
